import React from 'react';
import cx from 'classnames';
import '../../styles/PlayerHeader/PlayerName.scss';

const PlayerName = ({ name, className }) => {
  return <div className={cx('hp-name', { [className]: !!className })}>{name}</div>;
};

export default PlayerName;
